import $ from 'jquery';

window.addEventListener('load', function() {

  var $news_list = $('.js-list-news');
  
  if(!$news_list.length)
    return;
  
  var paged = $news_list.attr('data-paged') ? parseInt($news_list.attr('data-paged')) : 1;
  var filter = $news_list.attr('data-filter') ? $news_list.attr('data-filter') : '';
  var maxnumpages = $('.js-list-news-item').attr('data-maxnumpages') ? $('.js-list-news-item').attr('data-maxnumpages') : '';
  var posts_per_page = $news_list.attr('data-postsperpage') ? $news_list.attr('data-postsperpage') : 8;
  var news_type = $('select#select_type').val();

  var $loadMoreButton = $('.js-load-more-news');

  // Load first Page & hidden Second Page
  loadNews(paged);
  paged ++;

  // On Load More Click, Show n+1 Page and Load hidden n+2 Page
  $loadMoreButton.on('click', function(){
    paged ++;
    loadNews(paged);
  });
  
  // On filters change, create a new List
  $( "select#select_type" ).change(function() {
    $news_list.empty();
    paged = 1;
    news_type = $('select#select_type').val();
    loadNews(paged);
    paged ++;
  });

  // Show previous Page, Load hidden next Page with filters
  function loadNews(paged){

    $('.js-list-news-item[data-paged='+(paged-1)+']').show();
    
    $loadMoreButton.hide();

    // Ajax Post
    $.ajax({
      cache: true,
      url: ajaxurl,
      type: 'get',
      data: {
        action: 'load_news',
        filter: filter,
        paged: paged,
        posts_per_page: posts_per_page,
        news_type: news_type,
      },
      success: function( html ) {
        
        maxnumpages = $('.js-list-news-item').attr('data-maxnumpages') ? $('.js-list-news-item').attr('data-maxnumpages') : 0;
        if( maxnumpages >= paged  )
          $loadMoreButton.show();

        $news_list.append( html );
        if(paged == 1)
          loadNews(2);
      }
    });

  }

});




